import { Injectable } from '@angular/core';
import { userEmail } from '@models/global.model';
import { InstallationCode, InstallationCodeResponse } from '@models/installation.model';
import { ActualUser } from '@models/user.model';
import { Store } from '@ngrx/store';
import { RemoveUserData, SetActualUser } from 'app/store/actions';
import { AppState } from 'app/store/app.reducer';
import { ConfigurationState } from 'app/store/models/store.model';

@Injectable({
  providedIn: 'root'
})
export class PersistenceService {

  constructor(private store: Store<AppState>) { }

  setLocal(key: string, data: any) {
    try {
      localStorage.setItem(key, data);
    } catch (error) {
    }
  }

  getLocal(key: string) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return;
    }
  }

  getSession(key: string) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return;
    }
  }

  getCurrentUser(): any {
    let currentUserResponse: any;
    let currentUser: any = localStorage.getItem('userEmails');
    if (currentUser != null) {
      currentUserResponse = JSON.parse(currentUser);
      currentUserResponse = new Array(currentUserResponse)[0][0]
    }
    return currentUserResponse;
  }

  //hidratate store (call app.component)
  hidratateStore() {
    if (this.getSession('userEmails')) {
      this.store.dispatch(new SetActualUser(this.getCurrentUser()));
    }
  }

  setInstallationCode( arrayPreviousInstallationCodes: Array<InstallationCodeResponse> ) {
    let arrayToSend = [...arrayPreviousInstallationCodes];
    let arrayInstallationCodes = this.getInstallationCode();
    if (arrayInstallationCodes) {
      arrayInstallationCodes.forEach((codigoInstalacion) => {
        if (
          arrayToSend.filter((codInstalacion) => codInstalacion.codigoInstalacion == codigoInstalacion.codigoInstalacion).length == 0) {
          arrayToSend.push(codigoInstalacion);
        }
      });
    }
    localStorage.setItem('installationCodes', JSON.stringify(arrayToSend));
  }

  getInstallationCode(): Array<InstallationCodeResponse> | null {
    let installationCodes = localStorage.getItem('installationCodes');
    let arrayInstallationCodes = null;
    if (installationCodes) {
      arrayInstallationCodes = JSON.parse(
        installationCodes
      ) as Array<InstallationCodeResponse>;
      if (arrayInstallationCodes.length == 0) {
        arrayInstallationCodes = null;
      }
    }
    return arrayInstallationCodes;
  }

  setActualUser(actualUser: ActualUser) {
    this.removeActualUser();
    localStorage.setItem('actualUser', JSON.stringify(actualUser));
  }

  getActualUser(): ActualUser | null {
    let actualUserResponse = null;
    let actualUser = localStorage.getItem('actualUser');
    if (actualUser) {
      actualUserResponse = JSON.parse(actualUser) as ActualUser;
    }
    return actualUserResponse;
  }

  setEmailActualUser(emailActualUser: Array<userEmail>) {
    let arrayToSend = [...emailActualUser];
    let arrayUserEmails = this.getDataActualUser();
    if (arrayUserEmails) {
      arrayUserEmails.forEach((emails) => {
        if (
          arrayToSend.filter((userEmail) => userEmail.email == emails.email).length == 0) {
          arrayToSend.push(emails);
        }
      });
    }
    localStorage.setItem('userEmails', JSON.stringify(arrayToSend));
  }

  getDataActualUser(): Array<userEmail> | null {
    let userEmails = localStorage.getItem('userEmails');
    let arrayActualUserResponse = null;
    if (userEmails) {
      arrayActualUserResponse = JSON.parse(userEmails) as Array<userEmail>;
    }
    if (arrayActualUserResponse?.length == 0) {
      arrayActualUserResponse = null
    }
    return arrayActualUserResponse;
  }

  removeActualUser() {
    localStorage.removeItem('actualUser');
    this.store.dispatch(new RemoveUserData());
    // localStorage.removeItem('userEmails');
  }

  removeInstallation(installationCodeToRemove: string) {
    let arrayToSend: any[] = [];
    let arrayInstallationCodes = this.getInstallationCode();
    if (arrayInstallationCodes) {
      arrayInstallationCodes.forEach((codigoInstalacion) => {
        if (codigoInstalacion.codigoInstalacion != installationCodeToRemove) {
          arrayToSend.push(codigoInstalacion);
        }
      });
      localStorage.removeItem('installationCodes');
      localStorage.removeItem('actualUser');
      localStorage.setItem('installationCodes', JSON.stringify(arrayToSend));
    }
  }

  recuperarDatos(): ConfigurationState {
    return new ConfigurationState(
      this.getInstallationCode(),
      this.getActualUser(),
      null,
    );
  }

}
